import CenteredSpinner from "@/components/CenteredSpinner";
import { ScrollArea } from "@/components/ui/scroll-area";
import DashboardExpandableWidgets from "@/domain/enums/DashboardExpandableWidgets";
import FeatureFlag from "@/domain/enums/FeatureFlag";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import dashboardStore, {
    collapseWidget,
    expandWidget,
} from "@/stores/dashboardStore";
import { useFeatureFlag } from "@cs_teamwaydev/mailvista-sdk_react";
import { useSelector } from "@tanstack/react-store";
import DashboardCalendar from "./calendar/DashboardCalendar";
import Repartition from "./repartition/Repartition";
import DashboardTips from "./tips/Tips";
import DashboardTodos from "./todo/DashboardTodos";

const DashboardWidgets = () => {
    const { data: user } = useGetUserProfile();
    const isAgendaAccessEnabled = useFeatureFlag(
        FeatureFlag.AGENDA_ENABLE_ACCESS,
    );
    const expandedWidget = useSelector(
        dashboardStore,
        (state) => state.expandedWidget,
    );

    if (!user) {
        return <CenteredSpinner />;
    }

    const widgetsParams = user.settings.displayPreferences.dashboardWidgets;

    return (
        <ScrollArea
            className="h-[calc(100vh-5rem)]"
            style={
                expandedWidget
                    ? {}
                    : {
                          maskImage:
                              "linear-gradient(to bottom, transparent 0%, black 5%, black 95%, transparent 100%)",
                          WebkitMaskImage:
                              "linear-gradient(to bottom, transparent 0%, black 5%, black 95%, transparent 100%)",
                      }
            }
            variant="ghost"
            viewportClassName="dashboard-scroll-viewport"
        >
            <div className="flex w-[35vw] flex-wrap gap-6 pb-20 pt-10">
                {widgetsParams.showRepartition && <Repartition />}
                {widgetsParams.showTipofTheDay && <DashboardTips />}
                {widgetsParams.showCalendar && isAgendaAccessEnabled && (
                    <DashboardCalendar
                        isExpanded={
                            expandedWidget ===
                            DashboardExpandableWidgets.CALENDAR
                        }
                        onCollapse={collapseWidget}
                        onExpand={() =>
                            expandWidget(DashboardExpandableWidgets.CALENDAR)
                        }
                    />
                )}
                {widgetsParams.showTodo && (
                    <DashboardTodos
                        isExpanded={
                            expandedWidget === DashboardExpandableWidgets.TODO
                        }
                        onCollapse={collapseWidget}
                        onExpand={() =>
                            expandWidget(DashboardExpandableWidgets.TODO)
                        }
                    />
                )}
            </div>
        </ScrollArea>
    );
};

export default DashboardWidgets;
